import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/rootReducer';

export const selectOrderBumpForm = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => orderBumpForm
);

export const selectMainProduct = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => orderBumpForm.mainProduct
);

export const selectBumpsItems = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => orderBumpForm.orderBumpsProducts
);

export const selectRemovedItemsContentIds = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => orderBumpForm.removedItemsContentIds
);

export const selectClearCacheContentIds = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => orderBumpForm.clearCacheContentIds
);

export const selectBumpsItemsLimit = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => orderBumpForm.bumpItemsLimit || 1
);

export const selectTitle = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => orderBumpForm.title
);

export const selectIsLoading = createSelector(
  ({ orderBumpForm }: RootState) => ({ orderBumpForm }),
  ({ orderBumpForm }) => !!orderBumpForm.isLoading
);
